
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#515358","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11.457 10.881l3.16 3.16a.392.392 0 010 .576.392.392 0 01-.576 0l-3.16-3.16c.203-.18.397-.373.576-.576M6.551 1.228a5.313 5.313 0 015.322 5.322 5.313 5.313 0 01-5.322 5.323A5.314 5.314 0 011.228 6.55a5.314 5.314 0 015.323-5.322m0-1.228C2.94 0 0 2.94 0 6.55a6.56 6.56 0 006.551 6.551c1.214 0 2.35-.33 3.326-.909l3.294 3.295a1.648 1.648 0 002.316 0 1.648 1.648 0 000-2.316l-3.294-3.294a6.528 6.528 0 00.908-3.327A6.56 6.56 0 006.551 0"}}),_c('path',{attrs:{"d":"M9.588 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M9.176 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M8.765 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M8.353 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M7.941 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M7.529 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M7.118 6.294h1v1h-1zM6.294 9.588h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 9.176h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 8.353h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 8.765h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 7.941h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 7.118h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 7.529h1v1h-1zM6.294 5.059h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 5.471h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 4.647h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 3.824h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 4.235h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 3.412h1v1h-1z"}}),_c('path',{attrs:{"d":"M6.294 3h1v1h-1zM5.471 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M5.059 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M4.647 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M4.235 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M3.824 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M3.412 6.294h1v1h-1z"}}),_c('path',{attrs:{"d":"M3 6.294h1v1H3z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/objectMenu/detail.svg